import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
  flex-direction: ${props => props.dir};
  flex-grow: ${props => props.fg};

  align-items: ${props => props.align || 'flex-start'};
  justify-content: ${props => props.justify || 'flex-start'};

  min-width: ${props => props.minw || props.w};
  width: ${props => props.w};
  max-width: ${props => props.maxw};

  min-height: ${props => props.minh || props.h};
  height: ${props => props.h};
  max-height: ${props => props.maxh};
`;

export default Flex;
